import { proxy } from "valtio";

const store = proxy({});

export default store;
